import { render, staticRenderFns } from "./SelectAgency.vue?vue&type=template&id=5fcb10ca&scoped=true&"
import script from "./SelectAgency.vue?vue&type=script&lang=js&"
export * from "./SelectAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb10ca",
  null
  
)

export default component.exports